<template>
    <v-dialog-old ref="dialog" id="withdrawalDialog">
        <WithdrawalRejectDialog ref="withdrawalRejectDialog" @rejected="reason => makeRequest('reject', reason)"/>
        <ReceiptRejectDialog ref="receiptRejectDialog" @rejected="reason => makeRequest('rejectReceipt', reason)"/>

        <fieldset disabled>
            <legend>Врач</legend>
            <span>
                <label>ФИО</label>
                <input :value="withdrawal.doctor.name" readonly/>
            </span>
            <span>
                <label>URL</label>
                <span class="input text-ellipsis readonlyInput">
                  <a :href="withdrawal.doctor.url" target="_blank" class="text-ellipsis">
                    {{ withdrawal.doctor.url }}
                  </a>
                </span>
            </span>
            <span>
                <label>Сумма</label>
                <input :value="withdrawal.amount" readonly/>
            </span>
        </fieldset>

        <fieldset disabled>
            <legend>Реквизиты</legend>
            <span>
                <label>ИНН</label>
                <input type="text" :value="withdrawal.paymentData.INN" readonly>
            </span>
            <span>
                <label>Налоговый режим</label>
                <input type="text"
                       :value="withdrawal.paymentData.tax_type === 'I_P' ? 'Индивидуальный предприниматель' : 'Самозанятый'"
                       readonly>
            </span>
            <span v-if="withdrawal.paymentData.tax_type === 'I_P'">
                <label>ОГРНИП</label>
                <input type="text" :value="withdrawal.paymentData.OGRNIP" readonly>
            </span>
            <span>
                <label>Наименование банка</label>
                <input type="text" :value="withdrawal.paymentData.bank_name" readonly>
            </span>
            <span>
                <label>БИК</label>
                <input type="text" :value="withdrawal.paymentData.BIK" readonly>
            </span>
            <span>
                <label>Корреспондентский счет</label>
                <input type="text" :value="withdrawal.paymentData.correspondent_account" readonly>
            </span>
            <span>
                <label>Счет получателя</label>
                <input type="text" :value="withdrawal.paymentData.recipient_account" readonly>
            </span>
        </fieldset>

        <fieldset v-if="withdrawal.paymentData.tax_type === 'SELF_EMPLOYED'" disabled>
            <legend>Чек</legend>
            <template v-for="(attachment, index) in withdrawal.attachments">
                      <span style="display: flex;align-items: flex-start;flex-direction: column;">
                          <label>Чек</label>
                          <a :href="prepareFileUrl(attachment.url)"
                             target="_blank"
                             style="display: block; width: fit-content;">
                              {{ attachment.title}}
                          </a>
                          <template v-if="attachment.description">
                              <label>URL</label>
                              <span v-if="attachment.description === 'Отсутствует QR-код'" style="color: red;">
                                  Отсутствует QR-код
                              </span>
                              <a v-else>{{ attachment.description }}</a>
                          </template>

                      </span>
                <hr v-if="index !== withdrawal.attachments.length - 1" style="margin: 5px 0 5px 0"/>
            </template>
        </fieldset>

        <footer v-if="$can('admin.consult.withdrawals.moderate')">
            <v-loading-component v-if="withdrawal.status === 'IN_PROCESS'" @click="makeRequest('accept')">
                <template slot-scope="{ loadingClass }">
                    <button :class="['green', loadingClass]">
                        $ отправлены
                    </button>
                </template>
            </v-loading-component>

            <button v-if="withdrawal.status === 'IN_PROCESS'" @click="openRejectWithdrawalDialog" class="red">
                Отклонить
            </button>

            <v-loading-component v-if="withdrawal.attachments.length && (withdrawal.status === 'MONEY_SENT' || withdrawal.status === 'BLOCKED')"
                                 @click="makeRequest('acceptReceipt')">
                <template slot-scope="{ loadingClass }">
                    <button :class="['green', loadingClass]">
                        Подтвердить чек
                    </button>
                </template>
            </v-loading-component>

            <button v-if="withdrawal.attachments.length && (withdrawal.status === 'MONEY_SENT' || withdrawal.status === 'BLOCKED')"
                    @click="openRejectReceiptDialog"
                    class="red">
                Отклонить чек
            </button>

            <div v-if="withdrawal.status === 'REJECTED'" class="text-left">
                Отклонена: {{ withdrawal.reject_reason }}
            </div>
            <div v-if="withdrawal.receipt_status === 'REJECTED'" class="text-left">
                Чек отклонен: {{ withdrawal.receipt_reject_reason }}
            </div>
        </footer>
    </v-dialog-old>
</template>

<script>
import WithdrawalRejectDialog from "@dialogs/admin/consult/WithdrawalReject";
import ReceiptRejectDialog from "@dialogs/admin/consult/ReceiptReject";

export default {
    components: {
        WithdrawalRejectDialog,
        ReceiptRejectDialog,
    },
    data: function () {
        return {
            withdrawal: {
                doctor: {},
                paymentData: {},
            },
        };
    },
    methods: {
        show (id) {
            return this.axios.post('withdrawals/read/' + id).then(response => {
                Object.assign(this.withdrawal, response.data.data);
                this.$refs.dialog.show();
            });
        },
        makeRequest(action, rejectReason = null) {
            this.axios.post(
                'withdrawals/' + action + '/' + this.withdrawal.id,
                rejectReason ? {reason: rejectReason} : {}
            ).then(() => {
                this.$emit('updated');
                this.$refs.dialog.hide();
            });
        },
        openRejectWithdrawalDialog() {
            this.$refs.withdrawalRejectDialog.show();
        },
        openRejectReceiptDialog() {
            this.$refs.receiptRejectDialog.show();
        },
        prepareFileUrl(fileUrl) {
            return fileUrl.indexOf('http') === -1 ? '//' + fileUrl : fileUrl;
        },
    }
}
</script>

<style lang="scss">
#withdrawalDialog {
    width: 800px;

    .readonlyInput {
        width: 100%;
        display: inline-block;
        background-color: #f8f8f8;

        &:hover {
            background-color: #f8f8f8;
        }
    }
}
</style>
